import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { DefaultGUID, RoleName } from 'src/app/@shared/constants/Constant';
import { CustomerService } from '@services/customer.service';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { IGroupMemberModel, IOpenGroupInfoPayload } from 'src/app/model/internalGroupChat.model';
import { Customer, VendorList } from 'src/app/service/customer.model';
import { MapMarkerService } from 'src/app/service/map-marker.service';
import { IGetMemberViewModel, ViewMemberModel } from 'src/app/service/memeber.model';
import { VendorService } from 'src/app/service/vendor.service';
import { BUDetailViewModel } from 'src/app/service/vendorDetailView.model';
import { InternalGroupChatService } from '../../internal-group-chat.service';
import { GroupInfoDialogComponent } from '../group-info-dialog/group-info-dialog.component';

@Component({
  selector: 'app-add-new-member-dialog',
  templateUrl: './add-new-member-dialog.component.html',
  styleUrls: ['./add-new-member-dialog.component.css'],
})
export class AddNewMemberDialogComponent implements OnInit {
  public user: ILoggedInUserViewModel;
  public selectionLimit: number = 20 - this.data.memberList.length;
  public memberType: boolean;
  public isInternal: boolean;
  public isCustomer: boolean;
  public isVendor: boolean;
  public isInternalDriver: boolean;
  public customerMemberLoader: boolean;
  public vendorLoader: boolean;
  public vendorMemberLoader: boolean;
  public customerLoader: boolean;
  public loader: boolean;
  public vendorBusinessUnitDetail: BUDetailViewModel;
  public customerBusinessUnitDetail: Customer;
  public customerBusinessUnitName: string;
  public vendorBusinessUnitName: string;
  public isAddMemberButtonDisabled: boolean;
  public internalMemberDataModel = {
    internalMemberList: [] as ViewMemberModel[],
    selectedInternalMemberList: [] as ViewMemberModel[],
    dropdownSetting: {
      singleSelection: false,
      itemsShowLimit: 2,
      idField: 'memberId',
      textField: 'name',
      allowSearchFilter: true,
      limitSelection: null,
    },
  };
  public customerMemberDataModel = {
    customerMemberList: [] as IGetMemberViewModel[],
    selectedCustomerMemberList: [] as ViewMemberModel[],
    dropdownSetting: {
      singleSelection: false,
      itemsShowLimit: 2,
      idField: 'memberId',
      textField: 'name',
      allowSearchFilter: true,
      limitSelection: null,
    },
  };
  public vendorDataModel = {
    vendorList: [],
    dropdownSetting: {
      displayKey: 'vendorName',
      search: true,
      placeholder: 'Select Vendor',
      height: '400px',
    },
    selectedVendor: { id: DefaultGUID, name: null } as VendorList,
  }; // reference in template file
  public vendorMemberDataModel = {
    vendorMemberList: [] as IGetMemberViewModel[],
    selectedVendorMemberList: [] as ViewMemberModel[],
    dropdownSetting: {
      singleSelection: false,
      itemsShowLimit: 2,
      idField: 'memberId',
      textField: 'name',
      allowSearchFilter: true,
      limitSelection: null,
    },
  };

  constructor(
    private _toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: IOpenGroupInfoPayload,
    private _vendorService: VendorService,
    private _customerService: CustomerService,
    private _internalGroupChatService: InternalGroupChatService,
    private _mapMarkerService: MapMarkerService,
    public dialogRef: MatDialogRef<GroupInfoDialogComponent>,
  ) {}

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternal =
      this.user.role === RoleName.ExecutiveAdmin || this.user.role === RoleName.Coordinator || this.user.role === RoleName.Management;
    this.isInternalDriver = this.user.role === RoleName.Driver;
    this.isCustomer = this.user.role === RoleName.CustomerAdmin || this.user.role === RoleName.CustomerCoordinator;
    this.isVendor =
      this.user.role === RoleName.VendorAdmin || this.user.role === RoleName.VendorCoordinator || this.user.role === RoleName.VendorDriver;
    this.memberType = this.isInternal || this.isInternalDriver;
    if (this.isInternal) {
      this.customerBusinessUnitName = this.data.serviceRequestDetail.customerName;
    } else if (this.isCustomer) {
      this.getCustomerBusinessUnitDetailByBusinessUnitID();
    } else if (this.isVendor) {
      this.getVendorBusinessUnitDetailByBusinessUnitID();
    }
    if (!!this.data.internalMemberList) {
      this.internalMemberDataModel.internalMemberList = this.data.internalMemberList?.filter((internalMember) => {
        if (
          this.data.memberList.every((member) => member.memberId !== internalMember.memberId) &&
          internalMember.role != null &&
          internalMember.role !== RoleName.InternalReadOnly
        ) {
          return true;
        }
        return false;
      });
    }
    this.radioButtonChange();
  }

  getCustomerBusinessUnitDetailByBusinessUnitID() {
    this.customerLoader = true;
    this._customerService.fetchCustomerListById(this.user.businessUnitId).subscribe(
      (response) => {
        this.customerLoader = false;
        this.customerBusinessUnitDetail = response;
        this.customerBusinessUnitName = this.customerBusinessUnitDetail ? this.customerBusinessUnitDetail.name : null;
      },
      (error) => {
        this.customerLoader = false;
        this._toast.warning('Unable to get the customer detail', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    );
  }

  getVendorBusinessUnitDetailByBusinessUnitID() {
    this.vendorLoader = true;
    this._vendorService.getBusinessUnitDetailById(this.user.businessUnitId).subscribe(
      (response) => {
        this.vendorLoader = false;
        this.vendorBusinessUnitDetail = response;
        this.vendorBusinessUnitName = this.vendorBusinessUnitDetail ? this.vendorBusinessUnitDetail.name : null;
        const vendor: VendorList = {
          id: this.user.businessUnitId,
          name: this.vendorBusinessUnitDetail.name,
        };
        this.getVendorMemberList(vendor);
      },
      (error) => {
        this.vendorLoader = false;
        this._toast.warning('Unable to get the vendor detail', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    );
  }

  checkTotalMemberSelected(): number {
    let totalMemberSelected: number =
      this.internalMemberDataModel.selectedInternalMemberList.length +
      this.customerMemberDataModel.selectedCustomerMemberList.length +
      this.vendorMemberDataModel.selectedVendorMemberList.length;
    return totalMemberSelected;
  }

  checkSelectionLimit() {
    let totalMemberSelected: number = this.checkTotalMemberSelected();
    this.internalMemberDataModel.dropdownSetting.limitSelection = this.selectionLimit - totalMemberSelected;
    this.customerMemberDataModel.dropdownSetting.limitSelection = this.selectionLimit - totalMemberSelected;
    this.vendorMemberDataModel.dropdownSetting.limitSelection = this.selectionLimit - totalMemberSelected;
  }

  radioButtonChange() {
    this.checkSelectionLimit();
    if (!this.memberType) {
      if (this.isInternal || this.isCustomer) {
        this.getCustomerMemberList(this.isInternal ? this.data.serviceRequestDetail.customerBuId : this.user.businessUnitId);
      }
      if (!this.isCustomer && !this.isVendor) {
        this.getVendorList();
      }
    }
  }

  getCustomerMemberList(customerBusinessUnitID: string) {
    this.customerMemberLoader = true;
    this._vendorService.getMemberListByCustomerID(customerBusinessUnitID).subscribe(
      (response) => {
        this.customerMemberLoader = false;
        this.customerMemberDataModel.customerMemberList = response?.filter((customerMember) => {
          if (this.data.memberList.every((member) => member.memberId !== customerMember.memberId) && customerMember.role != null) {
            return true;
          }
          return false;
        });
      },
      (error) => {
        this.customerMemberLoader = false;
        console.log(error);
        this._toast.warning('Unable to get customer member List', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    );
  }

  getVendorList() {
    this.vendorLoader = true;
    this._vendorService.getFilteredVendorsList().subscribe(
      (response) => {
        this.vendorLoader = false;
        this.vendorDataModel.vendorList = response;
      },
      (error) => {
        this.vendorLoader = false;
        console.log(error);
        this._toast.warning('Unable to get vendor List', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    );
  }

  getVendorMemberList(vendor: VendorList) {
    if (vendor.id !== DefaultGUID) {
      this.vendorMemberLoader = true;
      this._vendorService.getMemberListByCustomerID(vendor.id).subscribe(
        (response) => {
          this.vendorMemberLoader = false;
          this.vendorMemberDataModel.vendorMemberList = response?.filter((vendorMember) => {
            if (this.data.memberList.every((member) => member.memberId !== vendorMember.memberId) && vendorMember.role != null) {
              return true;
            }
            return false;
          });
        },
        (error) => {
          this.vendorMemberLoader = false;
          console.log(error);
          this._toast.warning('Unable to get vendor member List', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
        },
      );
    }
  }

  groupMemberList(): IGroupMemberModel[] {
    let memberIDList: IGroupMemberModel[] = [];
    this.internalMemberDataModel.selectedInternalMemberList.map((internalMember) => {
      memberIDList.push({
        isGroupAdmin: false,
        memberId: internalMember.memberId,
      });
    });
    this.customerMemberDataModel.selectedCustomerMemberList.map((customerMember) => {
      memberIDList.push({
        isGroupAdmin: false,
        memberId: customerMember.memberId,
      });
    });
    this.vendorMemberDataModel.selectedVendorMemberList.map((vendorMember) => {
      memberIDList.push({
        isGroupAdmin: false,
        memberId: vendorMember.memberId,
      });
    });
    return memberIDList;
  }

  addMember() {
    if (this.checkTotalMemberSelected() > 0) {
      let addMemberPayload: IGroupMemberModel[] = this.groupMemberList();
      this.loader = true;
      this.isAddMemberButtonDisabled = true;
      this._internalGroupChatService.addGroupMember(addMemberPayload, this.data?.groupDetail.chatGroupId, this.user.memberId).subscribe(
        (response) => {
          this.loader = false;
          this.isAddMemberButtonDisabled = false;
          const colorList: string[] = this._mapMarkerService.generateUniqueRouteColors(response.data.length);
          response.data.map((newMember, i) => {
            newMember.memberProfileColor = colorList[i];
          });
          this._internalGroupChatService.updateGroupInfoSubject$.next({
            serviceRequestDetail: this.data.serviceRequestDetail,
            groupDetail: this.data?.groupDetail,
            memberList: this.data.memberList.concat(response.data),
          });
          this.dialogRef.close(this.data.memberList.concat(response.data));
          this._toast.success('Member added successfully', 'Success', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
        },
        (error) => {
          this.loader = false;
          this.isAddMemberButtonDisabled = false;
          console.log(error);
          this._toast.warning('Unable to add new members. Please try again later!', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
        },
      );
    } else {
      this._toast.warning('Please select at least one Member!', 'Warning', {
        timeOut: 6000,
        positionClass: 'toast-top-center',
      });
    }
  }
}
